<via-help-resources-layout role="main">

    <h1 class="e-page-title">Get Started</h1>
    <p>Get Started. Welcome to Via. Follow these three steps to learn more about Via and how to use it. </p>

    <h2 class="e-content-heading">About Via</h2>
    <p>
        Via is a tool that continuously tracks online product pricing, assortment, and product attributes, organised by country, category,
        supplier, brand, stock keeping unit (SKU), and retailer. You can also analyse products with specific attributes, including pack
        sizes, packaging types, ethical labelling, other product claims, flavours or fragrances.
    </p>
    <p>
        Via extracts online retailer data on a daily basis, providing daily updates to price changes, new product launches, delistings, and
        discontinuations as they happen, visualised in a cross-country comparable and actionable way.
    </p>

    <div class="e-get-started-steps">
        <div>
            <div>
                <h5>STEP ONE:</h5>
                <h4>The interface</h4>
                <p>
                    Via guided help will take you through each section of the Via platform, providing an overview of how to use Via and how to
                    find the data you need. 
                </p>
            </div>
            <img src="/assets/images/help-resources/get-started-interface.png" alt="Example of guided help popup" />
            <button mat-button color="primary">
                LAUNCH VIA GUIDED HELP <i class="fa-regular fa-chevron-right"></i>
            </button>
        </div>
        <div>
            <div>
                <h5>STEP TWO:</h5>
                <h4>Terminology</h4>
                <p>
                    The information icons will provide descriptions of each section while using Via. These definitions can also be found in the
                    Definitions page in the help section. 
                </p>
            </div>
            <img src="/assets/images/help-resources/get-started-terminology.png" alt="Example of help icon popup" />
            <button mat-button color="primary" (click)="navigateToDefinitions()">
                READ DEFINITIONS <i class="fa-regular fa-chevron-right"></i>
            </button>
        </div>
        <div>
            <div>
                <h5>STEP THREE:</h5>
                <h4>Video tutorials</h4>
                <p>These videos will give you a step-by-step tutorial on how to perform certain actions in Via.</p>
            </div>
            <img src="/assets/images/help-resources/get-started-video.jpg" alt="Example video thumbnail" />
            <button mat-button color="primary">
                WATCH VIDEO TUTORIALS <i class="fa-regular fa-chevron-right"></i>
            </button>
        </div>
    </div>

</via-help-resources-layout>
